import React from 'react';

const DhukarrMiddle = ({ children }) => {

  return(

    <div className='dhukarrSectionMiddle'>

        {children}

    </div>
  )
}

export default DhukarrMiddle;
